module.exports = __webpack_public_path__ + "gbga.jpg?4051429dbda4f6f76f9044d0d41512f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gbga.jpg
// module id = 177
// module chunks = 0